module.exports = __webpack_public_path__ + "static/media/default-rune.f923e3cb.png";